import { NgModule, APP_INITIALIZER } from '@angular/core';
import { registerMosquitoScreenConfigurations } from '@icc/mosquito-screen/types';

export function registerMosquitoScreenConfigurator() {
    return () => {
        registerMosquitoScreenConfigurations();
    };
}
import { CommonModule } from '@angular/common';
import { TypesComponent } from './types/types.component';
import { DimensionsComponent } from './dimensions/dimensions.component';
import { VariantsComponent } from './variants/variants.component';
import { ColorsComponent } from './colors/colors.component';
import { MontagesComponent } from './montages/montages.component';
import { TypesListPageComponent } from './types-list-page/types-list-page.component';
import { ColorsListPageComponent } from './colors-list-page/colors-list-page.component';
import { MontagesListPageComponent } from './montages-list-page/montages-list-page.component';
import { NetTypesComponent } from './net-types/net-types.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import {
    MOSQUITOSCREEN_FEATURE_KEY,
    initialState as mosquitoScreenInitialState,
    mosquitoScreenReducer,
} from './+state/mosquito-screen.reducer';
import { MosquitoScreenEffects } from './+state/mosquito-screen.effects';
import { MosquitoScreenFacade } from './+state/mosquito-screen.facade';
import { SharedModule } from '@icc/configurator/shared';
import { ConfiguratorUiModule } from '@icc/configurator/ui';
import { ConfiguratorPagesModule } from '@icc/configurator/pages';
import { ColorsService } from './colors.service';
import { DimensionsService } from './dimensions.service';
import { MontagesService } from './montages.service';
import { SystemsService } from './systems.service';
import { TypesService } from './types.service';
import { MosquitoPriceModule } from './+price';


@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        ConfiguratorUiModule,
        ConfiguratorPagesModule,
        StoreModule.forFeature(MOSQUITOSCREEN_FEATURE_KEY, mosquitoScreenReducer, {
            initialState: mosquitoScreenInitialState,
        }),
        EffectsModule.forFeature([MosquitoScreenEffects]),
        MosquitoPriceModule,
    ],
    declarations: [
        TypesComponent,
        DimensionsComponent,
        VariantsComponent,
        ColorsComponent,
        MontagesComponent,
        TypesListPageComponent,
        ColorsListPageComponent,
        MontagesListPageComponent,
        NetTypesComponent,
    ],
    exports: [
        TypesComponent,
        DimensionsComponent,
        VariantsComponent,
        ColorsComponent,
        MontagesComponent,
        TypesListPageComponent,
        ColorsListPageComponent,
        MontagesListPageComponent,
        NetTypesComponent,
    ],
    providers: [
        MosquitoScreenFacade,
        ColorsService,
        DimensionsService,
        MontagesService,
        SystemsService,
        TypesService,
    ]
})
export class MosquitoScreenConfiguratorModule {}
export { ColorsListPageComponent };
